import { xor } from 'lodash';
import { connect } from 'react-redux';
import React, { useCallback } from 'react';
import { ButtonToolbar } from 'react-bootstrap';
import { selectOrgStakeholders } from '../../../../modules/orgStakeholders.js';
import { navigateToProjectReports } from '../../../links/index.jsx';
import StakeholderSearchSelect from '../../../StakeholderSearchSelect.jsx';

StakeholdersFilter.defaultProps = {
  selectedStakeholdersIds: [],
};

const mapStateToProps = (state) => ({
  orgStakeholders: selectOrgStakeholders(state),
});

function StakeholdersFilter({
  disabled,
  selectedStakeholdersIds,
  orgStakeholders,
}) {
  const selectedCount = selectedStakeholdersIds.length;

  const handleStakeholderSelect = useCallback(
    (stakeholder) => {
      const stakeholderId = stakeholder.id;
      navigateToProjectReports({
        organizationStakeholderIds: xor(selectedStakeholdersIds, [
          stakeholderId,
        ]),
      });
    },
    [selectedStakeholdersIds]
  );

  const handleClearAll = useCallback(() => {
    navigateToProjectReports({
      organizationStakeholderIds: [],
    });
  }, []);

  // Convert selectedStakeholdersIds array to object for StakeholderSearchSelect
  const selectedStakeholdersObj = selectedStakeholdersIds.reduce((acc, id) => {
    acc[id] = true;
    return acc;
  }, {});

  const title = selectedCount ? `${selectedCount} Selected` : 'All';

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        Stakeholder Group / Individual
      </div>
      <ButtonToolbar>
        <StakeholderSearchSelect
          stakeholders={orgStakeholders}
          selectedStakeholders={selectedStakeholdersObj}
          onSelectStakeholder={handleStakeholderSelect}
          onClearAll={handleClearAll}
          title={title}
          disabled={disabled}
          showArchived
          className="btn-block"
          combined
        />
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(StakeholdersFilter);
